import { GetPointHistoryNew } from "./Module/Customer";
import { isNewApiEnabled } from "./customerProfileFetch";

function extractResponseData(res) {
  return res?.data ?? res?.response?.data;
}

export async function fetchCollectPointHistory({ params }) {
  const empty = {
    status: false,
    result: null,
    rowCount: 0,
    source: null,
  };

  if (!isNewApiEnabled()) {
    console.log("[pointHistory] NEW_API_URL is not configured");
    return empty;
  }

  try {
    const res = await GetPointHistoryNew({ params });
    const responseData = extractResponseData(res);

    if (responseData?.resultCode === "20000") {
      return {
        status: true,
        result: responseData.resultData,
        rowCount: responseData.rowCount ?? 0,
        source: "new",
      };
    }

    console.log("[pointHistory] new API non-success >>", responseData);
    return { ...empty, source: "new", error: responseData };
  } catch (e) {
    console.log("[pointHistory] new API failed >>", e?.response?.data || e);
    return { ...empty, source: "new", error: e?.response?.data || e };
  }
}
